import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

import config from "../shared/data/config.json";
import { SubscriptionService } from "../shared/services/subscription.service";

@Component({
  selector: 'app-subscription-settings',
  templateUrl: './subscription-settings.component.html',
  styleUrls: ['./subscription-settings.component.scss'],
})
export class SubscriptionSettingsComponent implements OnInit {
  isLoading = true;
  email?: string;
  wallet?: string;
  notifyOnUnlock?: boolean;
  monthlySummary?: boolean;

  private key?: string;

  private modalRef?: BsModalRef;

  @ViewChild('subscribeModal') modalTemplate: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    const params = this.route.snapshot.queryParams;
    if (!params.walletId || !params.key) {
      this.router.navigate(['/']);
    } else {
      this.subscriptionService
        .getSubscription(params.walletId, params.key)
        .subscribe(
          (res: any) => {
            this.wallet = params.walletId;
            this.key = params.key;
            this.email = res.email;
            this.notifyOnUnlock = res.notifyOnUnlock;
            this.monthlySummary = res.monthlySummary;

            this.modalRef = this.modalService.show(
              this.modalTemplate,
              Object.assign(
                {},
                { class: 'staking modal-lg modal-dialog-centered' }
              )
            );
            this.isLoading = false;
          },
          (err) => {
            this.router.navigate(['/']);
          }
        );
    }
  }

  onSave(data: {
    walletId: string;
    email: string;
    notifyOnUnlock: boolean;
    monthlySummary: boolean;
  }) {
    this.subscriptionService
      .updateSubscription({
        projectName: config.projectName,
        walletId: this.wallet!,
        key: this.key!,
        monthlySummary: data.monthlySummary,
        notifyOnUnlock: data.notifyOnUnlock,
      })
      .subscribe((res) => {
        this.modalRef?.hide();
      });
  }
}
